import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

type BrandingPackage = 'premium' | 'whitelabelling';

@Component({
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, TranslocoModule],
  selector: 'db-branding-upsell-card',
  templateUrl: 'branding-upsell-card.component.html',
  styleUrls: ['branding-upsell-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandingUpsellCardComponent {
  package = input.required<BrandingPackage>();

  navigation = {
    billing: 'issuer.dashboard.billing.checkout',
    billingHref: 'issuer/dashboard/billing/checkout',
  };
  image = {
    premium: 'assets/images/branding-package/premium.svg',
    whitelabelling: 'assets/images/branding-package/whitelabelling.svg',
  };
}
